module.exports = __webpack_public_path__ + "img/energy_4.dc18da14.png";